import MainPageDemandas from '@/screens/demandas/MainPage'
import HomeDemandas from '@/screens/demandas/Home'
import MeusPaineis from '@/screens/demandas/components/MeusPaineis'
import PaineisCompartilhados from '@/screens/demandas/components/PaineisCompartilhados'
import ListagemDemandas from '@/screens/demandas/ListagemDemandas'
import Relatorios from '@/screens/demandas/Relatorios'

import PERFIL from '@/constants/perfil'

const setRouteGroup = group => {
  return { routeGroup: group }
}

const perfisGestaoDemandas = [PERFIL.GESTAO_DE_DEMANDAS.GESTOR_DE_DEMANDAS.codigo]

const demandas = [
  {
    path: '/demandas',
    name: PERFIL.GESTAO_DE_DEMANDAS.CODIGO_MODULO,
    meta: {
      codigoModulo: PERFIL.GESTAO_DE_DEMANDAS.CODIGO_MODULO,
      title: PERFIL.GESTAO_DE_DEMANDAS.TITULO_MODULO,
      perfis: perfisGestaoDemandas

    },
    component: MainPageDemandas,
    children: [
      {
        path: 'home',
        name: 'demandas/home',
        component: HomeDemandas,
        redirect: 'home/meusPaineis',
        meta: {
          ...setRouteGroup('GESTAO_DE_DEMANDAS')
        },
        children: [
          {
            path: 'meusPaineis',
            name: 'home/meusPaineis',
            component: MeusPaineis,
            meta: {
              ...setRouteGroup('GESTAO_DE_DEMANDAS')
            }
          },
          {
            path: 'paineisCompartilhados',
            name: 'home/paineisCompartilhados',
            component: PaineisCompartilhados,
            meta: {
              ...setRouteGroup('GESTAO_DE_DEMANDAS')
            }
          }
        ]
      },
      {
        path: 'demandasPainel',
        name: 'demandas/demandasPainel',
        component: ListagemDemandas,
        meta: {
          ...setRouteGroup('GESTAO_DE_DEMANDAS')
        }
      },
      {
        path: 'relatorios',
        name: 'demandas/relatorios',
        component: Relatorios,
        meta: {
          ...setRouteGroup('GESTAO_DE_DEMANDAS_RELATORIOS')
        }
      }
    ]
  }
]

export default demandas



// WEBPACK FOOTER //
// ./src/router/demandas.js